<template>
  <div class="w-full p-4 my-6">
    <smm-sub-nav />

    <div class="mb-4 flex flex-wrap gap-3 items-end">
      <div>
        <label class="text-xs text-gray-500">{{ $t('smm.common.social_network') }}</label>
        <select v-model="networkId" @change="load" class="block border rounded-lg p-2 mt-1 text-sm">
          <option value="">{{ $t('common.all') }}</option>
          <option v-for="n in networks" :key="n.id" :value="n.id">{{ n.name }}</option>
        </select>
      </div>
    </div>

    <div v-if="loading" class="text-center text-gray-500 py-12">{{ $t('common.loading') }}</div>

    <div v-else class="flex gap-3 overflow-x-auto pb-4">
      <div
        v-for="col in columns"
        :key="col.key"
        class="min-w-[220px] flex-1 bg-gray-100 rounded-lg p-2"
      >
        <h3 class="text-sm font-semibold text-gray-700 px-2 py-2">{{ col.label }}</h3>
        <div class="space-y-2 min-h-[120px]">
          <div
            v-for="card in board[col.key] || []"
            :key="card.id"
            class="bg-white rounded-lg p-3 shadow-sm border text-sm cursor-pointer hover:border-blue-300"
            @click="cycleStatus(card)"
          >
            <span class="text-xs text-gray-400">{{ card.social_network?.name }}</span>
            <p class="font-medium text-gray-900">{{ card.title }}</p>
            <p class="text-xs text-gray-500 mt-1">{{ card.scheduled_for }} · {{ card.format }}</p>
            <p class="text-xs text-gray-700 mt-2">{{ $t('smm.kanban.click_hint') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SmmSubNav from '@/components/smm/SmmSubNav.vue'

const COLUMN_ORDER = ['backlog', 'todo', 'in_progress', 'review', 'done']

export default {
  components: { SmmSubNav },
  data: () => ({
    networks: [],
    networkId: '',
    board: {},
    loading: true,
  }),
  computed: {
    columns() {
      return COLUMN_ORDER.map((key) => ({
        key,
        label: this.$t(`smm.status.${key}`),
      }))
    },
  },
  mounted() {
    this.loadNetworks().then(() => this.load())
  },
  methods: {
    async loadNetworks() {
      const { data } = await axios.get('/api/v1/smm/social-networks')
      this.networks = data.data
    },
    async load() {
      this.loading = true
      try {
        const params = { kanban: 1 }
        if (this.networkId) params.social_network_id = this.networkId
        const { data } = await axios.get('/api/v1/smm/content-items', { params })
        this.board = data.data
      } finally {
        this.loading = false
      }
    },
    async cycleStatus(card) {
      const idx = COLUMN_ORDER.indexOf(card.status)
      const next = COLUMN_ORDER[(idx + 1) % COLUMN_ORDER.length]
      await axios.patch(`/api/v1/smm/content-items/${card.id}`, { status: next })
      await this.load()
    },
  },
}
</script>
